import Lottie from "react-lottie";
import styled from "styled-components";

export const Container = styled.div`
  position: relative;
  background-color: transparent;
`;

export const ModalLoading = styled.div`
    transition: opacity .15s linear;
    position: fixed;
    top: 0;
    background: #0000005e;
    left: 0;
    z-index: 1050;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    overflow: hidden;
    outline: 0;
`

export const BodyLoading = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    border-radius: 0.3rem;
`